import { ProgressLabels } from 'components/registration-header/types'
import { ProducerContactSteps } from '../types'
import { InstallationTypes } from './types'

export const generatorContactFlow: ProducerContactSteps[] = [
  ProducerContactSteps.COMPANY_DATA,
  ProducerContactSteps.INSTALLATIONS,
  ProducerContactSteps.COMMENTS,
  ProducerContactSteps.CONFIRMATION
]

export const generatorProgressLabels: ProgressLabels = {
  [ProducerContactSteps.COMPANY_DATA]: {
    i18nKey: 'progressCompanyData',
    default: 'Je bedrijfsgegevens'
  },

  [ProducerContactSteps.INSTALLATIONS]: {
    i18nKey: 'progressInstallationData',
    default: 'Jouw installatie'
  },

  [ProducerContactSteps.COMMENTS]: {
    i18nKey: 'progressCommentsData',
    default: 'Opmerkingen'
  },

  [ProducerContactSteps.CONFIRMATION]: {
    i18nKey: 'progressConfirmationData',
    default: 'Bevestiging'
  }
}

export const installationLabels: ProgressLabels = {
  [InstallationTypes.NEW]: {
    i18nKey: 'newInstallation',
    default: 'Nieuwe installatie'
  },
  [InstallationTypes.EXISTING]: {
    i18nKey: 'existingInstallation',
    default: 'Bestaande installatie'
  }
}
